<input type="checkbox" id="menu-trigger" [checked]="showHamburger" (change)="toggleHamburger()"/>
<div class="header header--client" [ngClass]="{'header--faq': routeIsFaq}">
    <div class="header__content">
        <div class="header__icons">
            <a class="header__logo" href="http://www.massmutual.com/">
                <div class="header__logo-image" [ngClass]="{'header__logo-image--faq': routeIsFaq}"></div>
            </a>
            <label *ngIf="controller.loggedIn || routeIsLifeBridge" class="header__nav-menu" for="menu-trigger">
                <span></span><span></span><span></span><span></span>
            </label>
        </div>
        <div class="header__nav-wrapper">
            <ul *ngIf="!controller.loggedIn && routeIsLifeBridge" class="header__nav">
                <li class="header__nav-item"><a class="text-link--header-client" routerLink="faq" (click)="hideHamburger()">FAQ</a></li>
                <li class="header__nav-item"><a class="text-link--header-client" (click)="hideHamburger(); login()">Login</a></li>
                <li *ngIf="!routeIsHome" class="header__nav-item"><a class="header__button button button--small" routerLink="home" role="button" (click)="hideHamburger();">Get a Quote</a></li>
                <li *ngIf="routeIsHome" class="header__nav-item"><a class="header__button button button--small" role="button" (click)="scrollToQuickQuote(); hideHamburger();">Get a Quote</a></li>
            </ul>
            <ul *ngIf="controller.loggedIn" class="header__nav">
                <li class="header__nav-item"><a class="text-link--header-client" routerLink="account-center" (click)="hideHamburger()">Policies</a></li>
                <li class="header__nav-item"><a class="text-link--header-client" routerLink="faq" (click)="hideHamburger()">FAQ</a></li>
                <li class="header__nav-item"><a class="text-link--header-client" routerLink="settings" (click)="hideHamburger()">Settings</a></li>
                <li class="header__nav-item"><a class="text-link--header-client" (click)="hideHamburger(); logout();">Logout</a></li>
            </ul>
        </div>
    </div>
</div>
